export default __webpack_public_path__ + "static/media/v-mark-bg-gray.ffd9ed50.svg";